import e from "../managers/braze-instance.js";
export function removeSubscription(r) {
  e.X() && e.removeSubscription(r);
}
